// key names from the ECM API DocId and ComponentIds
export const ECM_DOC_ID_KEY = 'ecmDocId';
export const ECM_KEY_DOCID = 'docid';
export const ECM_COMPONENT_IDS_KEY = 'ecmComponentIds';

// Default values to be used in FPTIs for ECM API DocId and ComponentIds - default will be empty strings
export const ECM_DOC_ID_DEFAULT_VALUE = '';
export const ECM_COMPONENT_IDS_DEFAULT_VALUE = '';
